module.exports = __webpack_public_path__ + "media/images/phone/story-script_tap-visual@2x-8d892f884fecadbe17b4b1286d596831.png";